import ApiRequester from './ApiRequester';

export default class {
  constructor(url) {
    this.context = url;
    this.requester = null;
    this.lastCall = 0;
    this.currentCall = 0;

    return this;
  }

  finishCall() {
    this.lastCall += 1;
  }

  cancelPreviousRequest() {
    if (this.currentCall !== this.lastCall) {
      this.requester.cancelPreviousRequest();
    }
  }

  get(payload, exportToCA = false) {
    this.requester = new ApiRequester();

    let context = this.context

    if (exportToCA) {
      context += '-for-ca'
    }

    this.requester.url = `${context}/export?filter=${payload.filter}`;
    this.requester.method = 'GET';
    this.requester.responseType = 'blob';

    return this.requester.submitRequest();
  }
}
